import { InputTag } from 'mixs/base/input_mixin';
import TimeLag from 'utilities/timelag';
export class Text extends InputTag {
  lag: TimeLag;
  public init() {
    super.init();
    this.watch();
    this.lag = new TimeLag(this.onChangeLagged, 500)
  }
  public onChange(e) {
    if(this.opts.noDispatch){ return; }
    this.dispatch({value: e.target.value});
  }
  public onInput(e) {
    // console.log('onInput')
    // this.lag.start(e.target.value);
  }
  public onChangeLagged(params) {
    if(this.opts.noDispatch){ return; }
    this.dispatch({value: params});
  }
}
